"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _rating = require("./rating");
Object.keys(_rating).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _rating[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _rating[key];
    }
  });
});